export default "__VITE_ASSET__h83L2zPn__"